import React,{useState} from 'react';
import  { useNavigate  } from 'react-router-dom';
import { Layout, Image, Divider, Drawer, Button  } from 'antd';
import Navbarmenu from "./navbarmenu";
import logo from '../../ceylonikalogo.png';
import {BellTwoTone, UserOutlined, CalendarOutlined} from '@ant-design/icons';
import {MAINAPIURL,MAINVERSION} from '../appsettings';
 
const { Header } = Layout;

const Headerdiv = () => {
  
  const navigate = useNavigate();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const UserID = localStorage.getItem("USERID");

  const [open, setOpen] = useState(false);
  const [notificationsummary, setNotificationsummary] = useState([]);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  React.useEffect(()=>{

    
        
    if(ApiURL === "" || ApiURL === null || UserID === "" || UserID === null){
      navigate('/login');
    }

  
    
    }, [ApiURL,UserID,navigate]);

    return (
        <Header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: '0 10px',
        }}
      >

        <h4 style={{margin:"5px"}}><Image src={logo}  height="50px" style={{width:"auto",}}  preview={false} /> ERP {MAINVERSION}</h4>
        
        <Divider type="vertical" style={{
          borderColor: '#10071a',
        }} />
        
        <Navbarmenu />

        <Divider type="vertical" style={{
          borderColor: '#10071a',
        }} />

        <Button type="text" shape="round" icon={<BellTwoTone />} onClick={showDrawer} />

        <Drawer title="Recent Notifications" onClose={onClose} open={open}>
          
          <h4>Action History</h4>

        </Drawer>
        
      </Header>
    );
  };
  export default Headerdiv;